var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fiftyContainer"},[_c('br'),_c('div',{staticClass:"partnerContainer"},[_c('fourth-component')],1),_c('div',{staticClass:"oracleContainer"},[_c('key-group')],1),_c('div',{staticClass:"founderContainer"},[_c('sixth-component')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }